export const adminMailingOrder = [
  'assign_zone_to_addresses_started',
  'assign_zone_to_addresses_finished',
  'import_diet_prices_started',
  'import_diet_prices_finished',
  'diet_reminder',
  'system_created_new_dish_sizes',
  'employee_welcome',
  'lost_password_admin',
  'daily_statistics',
];

export const clientMailingOrder = [
  'new_account',
  'remove_account',
  'lost_password',
  'new_order_v2',
  'order_verified',
  'waiting_order_status_change_paid',
  'waiting_order_status_change_canceled',
  'paid_order_status_change_canceled',
  'subscription_renewed_order_successful',
  'subscription_renewed_order_failed',
  'client_notification',
  'change_with_refund',
  'change_with_surcharge',
  'change_bag_dishes',
  'bag_delivered',
  'cancel_bags',
  'menu_published',
  'menu_assistant_failed_suggestion',
  'mass_mail',
  'money_box_points_expiring',
];

export const clientToggleable = ['change_bag_dishes', 'bag_delivered'];

export const mailingOptions = t => {
  const options = {
    // eslint-disable-next-line camelcase -- FIXME
    diet_reminder: t('mailNotification.mailingOptions.dietReminder'),
    // eslint-disable-next-line camelcase -- FIXME
    new_account: t('mailNotification.mailingOptions.newAccount'),
    // eslint-disable-next-line camelcase -- FIXME
    new_order_v2: t('mailNotification.mailingOptions.newOrder'),
    // eslint-disable-next-line camelcase -- FIXME
    change_with_surcharge: t(
      'mailNotification.mailingOptions.changeWithSurcharge'
    ),
    // eslint-disable-next-line camelcase -- FIXME
    change_with_refund: t('mailNotification.mailingOptions.changeWithRefund'),
    // eslint-disable-next-line camelcase -- FIXME
    order_status_change: t('mailNotification.mailingOptions.orderStatusChange'),
    // eslint-disable-next-line camelcase -- FIXME
    waiting_order_status_change_paid: t(
      'mailNotification.mailingOptions.waitingOrderStatusChangePaid'
    ),
    // eslint-disable-next-line camelcase -- FIXME
    waiting_order_status_change_canceled: t(
      'mailNotification.mailingOptions.waitingOrderStatusChangeCanceled'
    ),
    // eslint-disable-next-line camelcase -- FIXME
    paid_order_status_change_canceled: t(
      'mailNotification.mailingOptions.paidOrderStatusChangeCanceled'
    ),
    // eslint-disable-next-line camelcase -- FIXME
    remove_account: t('mailNotification.mailingOptions.removeAccount'),
    // eslint-disable-next-line camelcase -- FIXME
    lost_password_admin: t('mailNotification.mailingOptions.lostPasswordAdmin'),
    // eslint-disable-next-line camelcase -- FIXME
    lost_password: t('mailNotification.mailingOptions.lostPassword'),
    // eslint-disable-next-line camelcase -- FIXME
    assign_zone_to_addresses_started: t(
      'mailNotification.mailingOptions.assignZoneToAddressStarted'
    ),
    // eslint-disable-next-line camelcase -- FIXME
    assign_zone_to_addresses_finished: t(
      'mailNotification.mailingOptions.assignZoneToAddressFinished'
    ),
    // eslint-disable-next-line camelcase -- FIXME
    subscription_renewed_order_successful: t(
      'mailNotification.mailingOptions.subscriptionRenewedOrderSuccessfull'
    ),
    // eslint-disable-next-line camelcase -- FIXME
    subscription_renewed_order_failed: t(
      'mailNotification.mailingOptions.subscriptionRenewedOrderFailed'
    ),
    // eslint-disable-next-line camelcase -- FIXME
    change_delivery: t('mailNotification.mailingOptions.changeDelivery'),
    // eslint-disable-next-line camelcase -- FIXME
    change_bag_dishes: t('mailNotification.mailingOptions.changeDish'),
    // eslint-disable-next-line camelcase -- FIXME
    order_verified: t('mailNotification.mailingOptions.orderVerified'),
    // eslint-disable-next-line camelcase -- FIXME
    client_notification: t(
      'mailNotification.mailingOptions.clientNotification'
    ),
    // eslint-disable-next-line camelcase -- FIXME
    cancel_bags: t('mailNotification.mailingOptions.cancelBags'),
    // eslint-disable-next-line camelcase -- FIXME
    menu_published: t('mailNotification.mailingOptions.menuPublished'),
    // eslint-disable-next-line camelcase -- FIXME
    employee_welcome: t('mailNotification.mailingOptions.employeeWelcome'),
    // eslint-disable-next-line camelcase -- FIXME
    bag_delivered: t('mailNotification.mailingOptions.bagDelivered'),
    // eslint-disable-next-line camelcase -- FIXME
    import_diet_prices_finished: t(
      'mailNotification.mailingOptions.import_diet_prices_finished'
    ),
    // eslint-disable-next-line camelcase -- FIXME
    import_diet_prices_started: t(
      'mailNotification.mailingOptions.import_diet_prices_started'
    ),
    // eslint-disable-next-line camelcase -- FIXME
    menu_assistant_failed_suggestion: t(
      'mailNotification.mailingOptions.menu_assistant_failed_suggestion'
    ),
    // eslint-disable-next-line camelcase -- FIXME
    mass_mail: t('mailNotification.mailingOptions.mass_mail'),
    // eslint-disable-next-line camelcase -- FIXME
    daily_statistics: t('mailNotification.mailingOptions.daily_statistics'),
    // eslint-disable-next-line camelcase -- key must match the snake_case mailKey returned by the API
    money_box_points_expiring: t(
      'mailNotification.mailingOptions.money_box_points_expiring'
    ),
  };

  return options;
};
